exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.fixed-width{\n    width: -moz-max-content;\n    width: max-content;\n    max-width: 50% !important;\n}\n", ""]);

// exports
